var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTvPermissionSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 258,
    viewBox: "0 0 258 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12527_2535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258 128.627L136.825 128.315L256.105 106.967L255.975 106.232L136.589 126.966L250.348 85.2324L250.093 84.528L136.121 125.679L240.655 64.9685L240.905 64.8256L240.53 64.1757L135.434 124.494L227.838 46.5528L228.062 46.3682L227.578 45.7938L134.553 123.447L212.022 30.6427L212.206 30.4217L211.634 29.9409L133.506 122.566L193.681 17.7218L193.824 17.4696L193.177 17.0953L132.321 121.882L173.373 8.17987L173.472 7.90695L172.77 7.65222L131.034 121.411L151.719 2.31074L151.768 2.02482L151.033 1.89486L129.685 121.175L129.376 0H128.627L128.315 121.175L106.967 1.89486L106.232 2.02482L126.966 121.411L85.2324 7.65222L84.528 7.90695L125.679 121.879L64.8256 17.0953L64.1757 17.4696L124.494 122.566L46.5528 30.1618L46.3682 29.9409L45.7938 30.4217L123.447 123.447L30.6427 45.9783L30.4217 45.7938L29.9409 46.3682L122.566 124.494L17.7218 64.3213L17.4696 64.1757L17.0953 64.8256L121.882 125.679L7.90695 84.528L7.65222 85.2324L121.411 126.966L2.31074 106.281L2.02482 106.232L1.89486 106.967L121.175 128.315L0 128.627V129.376L121.175 129.685L1.89486 151.033L2.02482 151.768L121.411 131.034L7.65222 172.768L7.90695 173.472L121.882 132.321L17.3449 193.031L17.0953 193.177L17.4696 193.824L122.566 133.506L30.1618 211.447L29.9409 211.634L30.4217 212.206L123.447 134.553L45.9809 227.357L45.7938 227.578L46.3682 228.062L124.494 135.434L64.3213 240.278L64.1757 240.53L64.8256 240.905L125.679 136.118L84.6267 249.82L84.528 250.093L85.2324 250.348L126.966 136.589L106.281 255.689L106.232 255.975L106.967 256.105L128.315 136.825L128.627 258H129.376L129.685 136.825L151.033 256.105L151.768 255.975L131.034 136.589L172.77 250.348L173.472 250.093L132.321 136.121L193.177 240.905L193.824 240.53L133.506 135.434L211.447 227.838L211.634 228.062L212.206 227.578L134.553 134.553L227.357 212.022L227.578 212.206L228.062 211.634L135.434 133.506L240.278 193.679L240.53 193.824L240.905 193.177L136.118 132.321L250.093 173.472L250.348 172.768L136.589 131.034L255.689 151.719L255.975 151.768L256.105 151.033L136.825 129.685L258 129.376V128.627Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 62,
    width: 220,
    height: 131,
    rx: 3,
    fill: "#1F1F21",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.3195,
    y1: 206.267,
    x2: 106.32,
    y2: 193.267,
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 19.105,
    y2: -1,
    transform: "matrix(-0.732794 -0.680451 -0.680451 0.732794 165 207)",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    transform: "translate(99 99)",
    fill: "#1F1F21"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12527_2535)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 129,
    r: 30,
    fill: "#F44434"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M113.694 129L125.356 139.714L144.306 118.286",
    stroke: "white",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12527_2535",
    x: 69,
    y: 69,
    width: 120,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.958333 0 0 0 0 0.266537 0 0 0 0 0.203646 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12527_2535"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12527_2535",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12527_2535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 258,
    height: 258,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvPermissionSuccess);
export default __webpack_public_path__ + "static/media/tv_permission_success.cbb54eb0c78e71048502fb55fc2d66fc.svg";
export { ForwardRef as ReactComponent };